import React from "react";
import { motion } from "framer-motion";

const easeOut = [0.22, 1, 0.36, 1];

// Quiet fade + gentle rise on scroll into view
export const Reveal = ({ children, delay = 0, y = 24, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-10% 0px -10% 0px" }}
    transition={{ duration: 0.9, delay, ease: easeOut }}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for editorial headlines
export const MaskedLines = ({ lines, className = "", delay = 0, tag: Tag = "h1" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.14em]">
        <motion.span
          className="block leading-[1.1]"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * 0.12, ease: easeOut }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 1.1, delay, ease: easeOut }}
  >
    {children}
  </motion.div>
);
